import React, { useEffect, useState } from "react";
import { API_BASE } from "../../apiBase";
import { useAuth0 } from "@auth0/auth0-react";

export const MismatchGame = (props) => {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const [approved, setApproved] = useState(0);
  const [notApproved, setNotApproved] = useState(0);
  const [products, setProducts] = useState([]);
  const [ready, setReady] = useState(false);
  const [nickName, setNickName] = useState(localStorage.getItem("MorMNM"));
  const [leaderBoard, setLeaderBoard] = useState([]);
  const now = new Date();
  const MOMPlayed = `${String(now.getUTCMonth() + 1).padStart(2, '0')}${String(now.getUTCDate()).padStart(2, '0')}`;

  // Update subscription status
  useEffect(() => {
    const updateProducts = async () => {
      const accessToken = await getAccessTokenSilently();
      fetch(API_BASE + "/get_products_for_game/", {
        mode: "cors",
        headers: { Authorization: `Bearer ${accessToken}` },
      }).then((response) => response.json())
        .then((data) => {
          setProducts(data);
        });
    };

    if (!isLoading && isAuthenticated) {
      updateProducts();
    }
  }, [getAccessTokenSilently, isLoading, isAuthenticated]);

  const addScore = async () => {
    const accessToken = await getAccessTokenSilently();
    await fetch(API_BASE + "/mgs_add_score/" + nickName + `/${approved}/${notApproved}/`, {
      mode: "cors",
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    getLeaderboard();
  }

  const getLeaderboard = async () => {
    const accessToken = await getAccessTokenSilently();
    fetch(API_BASE + "/mgs_leaderboard/", {
      mode: "cors",
      headers: { Authorization: `Bearer ${accessToken}` },
    }).then((response) => response.json())
      .then((data) => {
        setLeaderBoard(data);
        setReady(true);
      });
  }

  const productSetApprove = async (product_url, approved, source_name, reporters) => {
    const accessToken = await getAccessTokenSilently();
    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json; charset=utf8",
        "Content-Type": "application/json; charset=utf8",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        product_url: product_url.replace(
          source_name,
          "X".repeat(source_name.length)
        ),
        approved: approved,
        reporters: reporters,
      }),
    };

    fetch(
      API_BASE + "/change_approved_status_product/",
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data !== "Succeed!") {
          console.log("ERROR!");
        }
      })
      .catch((error) => {
        console.log("ERROR!");
      });
  };

  if (!ready) {
    return (
      <div id="modal-js-example" className="modal is-active">
        <div class="modal-background" onClick={() => { props.closeModal() }}></div>

        <div className="modal-content" style={{ width: props.isMobile ? "90vw" : "40vw" }}>
          <div className="box" style={{ textAlign: "center" }}>
            <h1 className="title mt-5">Nepeto's <strong style={{ color: "green" }}>Match</strong> or <strong style={{ color: "red" }}>Mismatch!</strong></h1>
            <h2 style={{ fontWeight: "500", fontSize: "120%" }}>
              Think you've got an eye for detail? The rules are simple:<br />
              You're given two product - one from Amazon and one from a supplier.<br />
              Your mission? Decide if it's a <strong style={{ color: "green" }}>Match</strong> (same product) or a <strong style={{ color: "red" }}>Mismatch</strong> (different product, variation, oos, or pack size)!<br />
              <br />
              🎯 Play every day in our Daily <strong style={{ color: "green" }}>Match</strong> or <strong style={{ color: "red" }}>Mismatch</strong> Challenge 🎯<br />
              🏆 The top 3 players each month will win BIG PRIZES ($$) ! 🏆<br />
              <br />
              Are you up for the challenge?</h2>
            <br />
            <button
              className="button is-success"
              onClick={() => {
                setReady(true)
              }}
              disabled={products.length === 0 || localStorage.getItem("MOMPlayed") === MOMPlayed}
              style={{ fontSize: "190%", padding: "5%" }}
            >
              {products.length === 0 ? "Loading..." : (localStorage.getItem("MOMPlayed") === MOMPlayed ? "Played Today" : "Yes")}
            </button><br /><br />
            <button className="button is-link" disabled={products.length === 0} onClick={(e) => { getLeaderboard(); e.target.innerHTML = "Loading..."; e.target.disabled = true; }}>
              See Leaderboard
            </button><br /><br />
            <span
              className="is-danger"
              onClick={() => {
                props.closeModal()
              }}
              style={{ color: "red", texdivecoration: "underline", cursor: "pointer", fontWeight: "700" }}
            >
              Not Today - Lose Points
            </span>
          </div>
        </div>
      </div>
    );
  } else {
    if (leaderBoard.length > 0) {
      return <div id="modal-js-example" className="modal is-active">
        <div class="modal-background" onClick={() => { props.closeModal() }}></div>

        <div className="modal-content" style={{ width: props.isMobile ? "90vw" : "40vw" }}>
          <div className="box" style={{ textAlign: "center" }}>
            <h1 className="title mt-5">Nepeto's <strong style={{ color: "green" }}>Match</strong> or <strong style={{ color: "red" }}>Mismatch</strong> Leaderboard:</h1>
            <h2 style={{ fontWeight: "600", fontSize: "150%" }}>Your position is #{leaderBoard.findIndex(item => item.ys === true) + 1}</h2><br /><br />
            <div style={{ display: "block", maxHeight: "40vh", overflowY: "scroll" }}>
              <table className="table is-striped is-hoverable" style={{ margin: "auto", overflowY: "scroll", width: "60%", border: "3px solid gray", boxShadow: "0px 0px 5px 0px gray" }}>
                <thead>
                  <tr>
                    <th style={{ alignItems: "left", textAlign: "left" }}>#</th>
                    <th style={{ textAlign: "center" }}>Name</th>
                    <th style={{ textAlign: "center" }}>Score</th>
                  </tr>
                </thead>
                <tbody>
                  {leaderBoard.map((player, index) => (
                    <tr key={index} className={player.ys ? "is-selected" : ""}>
                      <td style={{ alignItems: "left", textAlign: "left" }}>
                        {index + 1}
                      </td>
                      <td>
                        {player.name.replaceAll("%20", " ").replace("null", "Unnicknamed")}
                      </td>
                      <td>
                        {player.score}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <br /><br />
            <button
              className="button is-danger"
              onClick={() => {
                props.closeModal()
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    }
    if (products.length === 0) {
      return (
        <div id="modal-js-example" className="modal is-active">
          <div class="modal-background" onClick={() => { props.closeModal() }}></div>

          <div className="modal-content" style={{ width: props.isMobile ? "90vw" : "40vw" }}>
            <div className="box" style={{ textAlign: "center" }}>
              <h1 className="title mt-5">Nepeto's <strong style={{ color: "green" }}>Match</strong> or <strong style={{ color: "red" }}>Mismatch!</strong></h1>
              <h2 style={{ fontWeight: "500", fontSize: "120%" }}>Awesome! You just completed your daily <strong style={{ color: "green" }}>Match</strong> or <strong style={{ color: "red" }}>Mismatch</strong> challenge!</h2><br />
              <h2 style={{ fontWeight: "500", fontSize: "120%" }}>
                Name: <input onChange={(e) => { setNickName(e.target.value); localStorage.setItem("MorMNM", e.target.value) }} placeholder={nickName ?? "Nickname"} />
              </h2><br />
              <button className="button is-success" onClick={(e) => { addScore(); e.target.innerHTML = "Loading..."; e.target.disabled = true; localStorage.setItem("MOMPlayed", MOMPlayed) }}>Click here to add your points and view the leaderboard</button>
              <br />
              <br />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="modal-js-example" className="modal is-active">
          <div class="modal-background" onClick={() => { props.closeModal() }}></div>

          <div className="modal-content" style={{ width: props.isMobile ? "90vw" : "40vw" }}>
            <div className="box" style={{ textAlign: "center" }}>
              <h1 className="title mt-5">Nepeto's <strong style={{ color: "green" }}>Match</strong> or <strong style={{ color: "red" }}>Mismatch!</strong></h1>
              <h2 className="mt-5" style={{ fontSize: "125%" }}>Check These Products: {products.length} Left !</h2>
              <hr />
              <div className="container" style={{ width: "100%", height: "auto" }}>
                <div style={{ margin: "2%" }}>
                  <strong>{products[0].title.split("| At Source:")[0]}</strong>
                  <br />Click on the images to open the product pages<br />
                  <strong style={{ color: "red" }}>Don't forget to check the pack size!</strong>
                </div>
                <div style={{ alignItems: "center", textAlign: "center" }}>
                  <a
                    href={products[0].url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="graphicon"
                      alt={products[0].title.split("| At Source:")[0]}
                      src={
                        products[0].img === ""
                          ? "/assets/noimage.png"
                          : products[0].img
                      }
                      style={{
                        borderRadius: "4.5vw",
                        border: "5px solid #E3D0DF",
                        height: "6.5vw",
                        width: "6.5vw",
                        objectFit: "scale-down",
                        position: "relative",
                        zIndex: "5",
                        cursor: "pointer",
                        backgroundColor: "white"
                      }}
                      loading="lazy"
                    />
                  </a>
                  <strong style={{ fontSize: "150%" }}>←{products[0].source}&emsp;Amazon→</strong>
                  <img
                    className="graphicon"
                    alt={products[0].title.split("| At Source:")[0]}
                    src={products[0].az_img}
                    style={{
                      borderRadius: "4.5vw",
                      border: "5px solid #E3D0DF",
                      height: "6.5vw",
                      width: "6.5vw",
                      objectFit: "scale-down",
                      position: "relative",
                      zIndex: "5",
                      cursor: "pointer",
                      backgroundColor: "white"
                    }}
                    loading="lazy"
                    onClick={() => window.open(products[0].asin)}
                  />
                  <br />
                  <strong onClick={() => {
                    window.open(products[0].asin, '_blank');
                    let secondOpened = null
                    secondOpened = window.open(products[0].url, '_blank');
                    if (!secondOpened) {
                      alert("Please enable pop-ups in your browser to continue.")
                    }
                  }} style={{ cursor: "pointer", textDecoration: "underline" }}>Open both links</strong>
                </div>
                <div style={{ display: "inline-flex", marginTop: "7%" }}>
                  <div>
                    <button
                      className="button is-success"
                      onClick={() => {
                        setApproved(approved + 1);
                        productSetApprove(products[0].url, true, products[0].source, products[0].reporters);
                        products.splice(0, 1);
                      }}
                    >
                      Match
                    </button>
                  </div>&emsp;&emsp;
                  <div>
                    <button
                      className="button is-danger"
                      onClick={() => {
                        setNotApproved(notApproved + 1);
                        productSetApprove(products[0].url, false, products[0].source, products[0].reporters);
                        products.splice(0, 1);
                      }}
                    >
                      Mismatch
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <strong>To earn the points, you must complete your daily challenge ({products.length} products left).</strong>
            </div>
          </div>
        </div>
      );
    }
  }
}


export default MismatchGame;
